<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-30 19:19:59
 * @FilePath: \gcp-fe\src\app\shop\components\noticeListNew.vue
 * @Description: 最新采购公告
-->
<template>
  <div class="notice-list mt20">
    <div class="titleBox">
      <div class="title">{{ $t("noticeList.newDynamicsList.label") }}</div>
      <div @click="handleViewAll" class="moreBox">
        {{ $t("noticeList.newDynamicsList.labelMore") }}
      </div>
    </div>

    <div class="navBox">
      <div
        v-for="(item1, index1) in newDynamicsList"
        :key="index1"
        :class="[
          'itemTitle',
          isZhCN ? `indexBox${index1}` : '',
          { isActive: index1 == num }
        ]"
        :title="item1.label"
        @click="handleClick(item1, index1)"
      >
        {{ item1.label }}
      </div>
      <div
        class="itemTitle"
        :title="$t('noticeList.newDynamicsList.labelItem6')"
      >
        {{ $t("noticeList.newDynamicsList.labelItem6") }}
      </div>
    </div>
    <div class="workDynamics">
      <ul v-if="nodeList.length > 0">
        <li
          v-for="(item2, index2) in nodeList"
          class="ellipsis ccui-clearfix itemBox"
          :key="index2"
        >
          <div class="infoBox">
            <p class="timeBox" v-if="item2.singUpDeadline">
              {{ item2.remainingTime }}
            </p>
            <p
              class="timeBox text-ellipsis"
              v-else
              :title="$t('noticeList.nodeList.label')"
            >
              {{ $t("noticeList.nodeList.label") }}
            </p>
            <p
              class="labelBox text-ellipsis"
              :title="$t('noticeList.nodeList.labelItem')"
            >
              {{ $t("noticeList.nodeList.labelItem") }}
            </p>
          </div>
          <div>
            <div class="workDynamics-item-title">
              <!-- 采购方式 -->
              <span class="iconTitle">{{ item2.mergePurchaseTypeName }}</span>
              <span
                style="cursor: pointer"
                class="ellipsis"
                :title="item2.noticeTitle"
                @click="handleOp(item2)"
              >
                <!-- 公告标题 -->
                {{ item2.noticeTitle }}
              </span>
            </div>
            <div class="workDynamics-item-type">
              <p
                v-if="item2.matBigClassesNameStr"
                class="item-title"
                :title="item2.matBigClassesNameStr"
              >
                {{ item2.matBigClassesNameStr }}
              </p>
              <p v-if="item2.matBigClassesNameStr" class="item-icon">|</p>
              <p>
                {{
                  $t("noticeList.nodeList.labelItem2")
                }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item2.noticeReleaseTime }}
              </p>
            </div>
          </div>
        </li>
      </ul>
      <div class="noneBox" v-else>{{ $t("noticeList.nodeList.noData") }}</div>
    </div>
    <!-- </el-tab-pane>
      <el-tab-pane label="工程服务(建设中)" disabled> </el-tab-pane> -->
    <!-- </el-tabs> -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { addUrlPerFix } from "@/basa/utils";
import {
  qryNoticeTopList,
  encBlackList,
  querySupJoinFlag
} from "@/app/shop/api/shopping";
import { calculateRemainingTime } from "../utils/utils";

export default {
  name: "noticeList",
  // props: ["workDynamicsList"],
  data() {
    return {
      nodeList: [],
      num: 0,
      agentIdEncrypt: "",
      openId: "",
      newDynamicsList: [
        {
          label: this.$t("noticeList.newDynamicsList.labelAll"), // 全部
          name: "all"
        },
        {
          label: this.$t("noticeList.newDynamicsList.labelItem1"), // 物 资
          name: "wuZi"
        },
        {
          label: this.$t("noticeList.newDynamicsList.labelItem2"), // 设备
          name: "sheBei"
        },
        {
          label: this.$t("noticeList.newDynamicsList.labelItem3"), // 工程分包
          name: "gongChengFenBao"
        },

        {
          label: this.$t("noticeList.newDynamicsList.labelItem5"), // 其它服务
          name: "qiTaFuWu"
        }
        // {
        //   label: "工程服务(建设中)",
        //   name: "gongChengFuWu"
        // }
      ],
      timer: null,
      schemeClass: undefined,
      dataSourceFlag: undefined
    };
  },
  computed: {
    isZhCN() {
      return Cookies.get("language") === "zh-cn";
    }
  },
  activated() {
    this.openId = Cookies.get("access_token");
    // console.log(this.openId,"openID");
    this.getNoticePageList();
    this.timer = setInterval(() => {
      this.getNoticePageList();
    }, 1000 * 60);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  // 在路由切换时添加监听
  watch: {
    $route() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  },
  methods: {
    handleClick(item, index) {
      this.num = index;
      switch (item.name) {
        case "all":
          this.schemeClass = undefined;
          this.dataSourceFlag = undefined;
          this.getNoticePageList();
          break;
        case "wuZi":
          this.schemeClass = 0;
          this.dataSourceFlag = undefined;
          this.getNoticePageList();
          break;
        case "sheBei":
          this.schemeClass = 1;
          this.dataSourceFlag = undefined;
          this.getNoticePageList();
          break;
        case "qiTaFuWu":
          this.schemeClass = 2;
          this.dataSourceFlag = undefined;
          this.getNoticePageList();
          break;
        case "gongChengFenBao":
          this.schemeClass = undefined;
          this.dataSourceFlag = 2;
          this.getNoticePageList();
          break;
        // case "gongChengFuWu":
        //   this.schemeClass = undefined;
        //   this.$message({
        //     message: "建设中",
        //     type: "error",
        //     duration: 3000,
        //     showClose: true,
        //     ccuiCustom: true
        //   });
        //   break;

        default:
          break;
      }
    },
    updateDisplay(endTime) {
      const time = calculateRemainingTime(endTime);
      return `${time.days}天${time.hours}小时${time.minutes}分`;
    },
    // 最新采购公告
    async getNoticePageList() {
      let params = {
        schemeClass: this.schemeClass,
        supCodeList: undefined,
        dataSourceFlag: this.dataSourceFlag,
        topNum: 8,
        languageFlag: Cookies.get("language")
      };
      qryNoticeTopList(params).then(res => {
        if (res.data.code === "0") {
          if (res.data.data.noticeInfoBOList.length) {
            res.data.data.noticeInfoBOList.forEach(item => {
              item.noticeReleaseTime = item.noticeReleaseTime.substring(
                0,
                item.noticeReleaseTime.lastIndexOf(":")
              );
              if (item.singUpDeadline) {
                this.$set(
                  item,
                  "remainingTime",
                  this.updateDisplay(item.singUpDeadline)
                );
              }
            });
            this.nodeList = res.data.data.noticeInfoBOList;
          } else {
            this.nodeList = [];
          }
        }
      });
    },
    handleOp(row) {
      console.log(row, "==================");
      if (row.dataSourceFlag == 3 || row.dataSourceFlag == 4) {
        // 跳转新加的页面 3融合专区（采购类 4, "融合专区（分包类
        let url = this.$router.resolve({
          path: "viewNoticeDetailNew",
          query: {
            baseAppId: row.baseAppId,
            // schemeCode: row.schemeCode,
            // schemeName: row.schemeName,
            noticeId: row.noticeId
            // opUnitName: row.opUnitName,
            // opUnitId: row.opUnitId,
            // purchaseType: row.purchaseType,
            // schemeStatus: row.schemeStatus,
            // checkFlag: row.checkFlag,
            // supCode: row.supCode,
            // supName: row.supName,
            // type: row.noticeType,
            // schemeId: row.schemeId,
          }
        });
        window.location.href = url.href;
      } else {
        const { schemeId, noticeId } = row;
        if (["107407", "118352", "119934"].includes(row.baseAppId)) {
          //租赁
          row.noticeDetailsUrl =
            addUrlPerFix(process.env.VUE_APP_YZ_URL) +
            `/leaseMall/viewNoticeDetail?schemeId=${schemeId}&noticeId=${noticeId}&schemeCode=${row.schemeCode}&schemeName=${row.schemeName}`;
        } else if (["118353", "107412", "119952"].includes(row.baseAppId)) {
          //物流
          row.noticeDetailsUrl =
            addUrlPerFix(process.env.VUE_APP_WLY_URL) +
            "/#/detail?" +
            row.noticeDetailsUrl.split("?")[1];
        } else if (["107428", "118497", "119912"].includes(row.baseAppId)) {
          //云仓
          row.noticeDetailsUrl =
            addUrlPerFix(process.env.VUE_APP_YC_URL) +
            `/leaseMall/viewNoticeDetail?schemeId=${row.schemeId}&noticeId=${row.noticeId}&schemeCode=${row.schemeCode}&schemeName=${row.schemeName}`;
        } else if (["100065"].includes(row.baseAppId)) {
          // 分包 /fenBaoDetail
          let objSession = {};
          if (
            sessionStorage.getItem("usedSupInfo") &&
            sessionStorage.getItem("usedSupInfo") != "undefined"
          ) {
            objSession = JSON.parse(sessionStorage.getItem("usedSupInfo"));
          }
          if (objSession?.supCode && Cookies.get("access_token")) {
            querySupJoinFlag({
              schemeId: row.schemeId,
              supCode: objSession.supCode
            }).then(res => {
              if (res.data.data.isJoin == 1) {
                // console.log(
                //   this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                //     "?CLIENT_ID=" +
                //     JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
                //     "&CALLBACK_URL=" +
                //     encodeURIComponent(
                //       `${this.$addUrlPerFix(
                //         process.env.VUE_APP_CRMSA_URL
                //       )}/bid/shop/participateSub?schemeId=${
                //         row.schemeId
                //       }&purchaseType=${row.purchaseType}&noticeStartTime=${
                //         new Date(row.noticeTimeStart).getTime()
                //         // row.noticeStartTime
                //       }&schemeName=${encodeURIComponent(
                //         row.schemeName
                //       )}&schemeCode=${encodeURIComponent(
                //         row.schemeCode
                //       )}&supCode=${row.supCode}&supName=${row.supName}&a=${
                //         JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
                //       }`
                //     )
                // );
                return window.open(
                  // this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                  //   "?CLIENT_ID=" +
                  //   JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
                  //   "&CALLBACK_URL=" +
                  //   encodeURIComponent(
                  //     `${addUrlPerFix(
                  //       process.env.VUE_APP_CRMSA_URL
                  //     )}/bid/bidFlowIndexSub?schemeId=${
                  //       row.schemeId
                  //     }&noticeStartTime=${new Date(row.noticeTimeStart).getTime()}&noticeEndTime=${row.noticeTimeEnd}&schemeName=${
                  //       row.schemeName
                  //     }&schemeCode=${
                  //       row.schemeCode
                  //     }${
                  //       this.supCode || row.supCode || objSession.supCode
                  //         ? "&supCode=" +
                  //           (this.supCode || row.supCode || objSession.supCode)
                  //         : ""
                  //     }&supName=${
                  //       JSON.parse(sessionStorage.usedSupInfo)?.supName
                  //     }&purchaseType=${row.purchaseType}&supplierFlag=1&a=${
                  //       JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
                  //     }`
                  //   )
                  this.$addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                    "?CLIENT_ID=" +
                    JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
                    "&CALLBACK_URL=" +
                    encodeURIComponent(
                      `${this.$addUrlPerFix(
                        process.env.VUE_APP_CRMSA_URL
                      )}/bid/bidFlowIndexSub?schemeId=${
                        row.schemeId
                      }&noticeStartTime=${new Date(
                        row.noticeTimeStart
                      ).getTime()}&noticeEndTime=${
                        new Date(row.noticeTimeEnd).getTime()
                        // row.noticeTimeEnd
                      }&schemeName=${row.schemeName}&schemeCode=${
                        row.schemeCode
                      }${
                        this.supCode || row.supCode || objSession.supCode
                          ? "&supCode=" +
                            (this.supCode || row.supCode || objSession.supCode)
                          : ""
                      }&supName=${encodeURIComponent(
                        JSON.parse(sessionStorage.usedSupInfo)?.supName
                      )}&purchaseType=${row.purchaseType}&supplierFlag=1&a=${
                        JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
                      }`
                    )
                );
              } else {
                encBlackList({
                  ids: [objSession.supCode],
                  purchaseUnitId: Number(row.opUnitId)
                }).then(res => {
                  if (res.data.data.isJoin === "0") {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: res.data.data.errMsg,
                      type: "error",
                      showClose: true,
                      ccuiCustom: true
                    });
                  } else {
                    let obj = {
                      schemeId: row.schemeId,
                      noticeId: row.noticeId,
                      opUnitName: row.opUnitName,
                      opUnitId: row.opUnitId,
                      purchaseType: row.purchaseType,
                      schemeStatus: row.schemeStatus,
                      supplierFlag: 1
                    };

                    if (row.checkFlag) {
                      obj.checkFlag = row.checkFlag;
                    }
                    let objs = JSON.parse(
                      sessionStorage.getItem("usedSupInfo")
                    );
                    if (objs?.supCode) {
                      obj.supCode =
                        row.supCode ||
                        objs.supCode ||
                        objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
                        "";
                      obj.encSupCode =
                        row.encSupCode ||
                        objs.encSupCode ||
                        objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
                        "";
                      obj.supName =
                        row.supName ||
                        objs.supName ||
                        objs.getSupInfoByLoginInfoRspBOList[0].supName ||
                        "";
                    }
                    this.$router.push({
                      path: "/fenBaoDetail",
                      query: obj
                    });
                  }
                });
              }
            });
          } else {
            let obj = {
              schemeId: row.schemeId,
              noticeId: row.noticeId,
              opUnitName: row.opUnitName,
              opUnitId: row.opUnitId,
              purchaseType: row.purchaseType,
              schemeStatus: row.schemeStatus,
              supplierFlag: 1
            };
            if (row.checkFlag) {
              obj.checkFlag = row.checkFlag;
            }
            let objs = objSession;
            // console.log(objs, "obj...");
            if (objs?.supCode) {
              obj.supCode =
                row.supCode ||
                objs.supCode ||
                objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
                "";
              obj.encSupCode =
                row.encSupCode ||
                objs.encSupCode ||
                objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
                "";
              obj.supName =
                row.supName ||
                objs.supName ||
                objs.getSupInfoByLoginInfoRspBOList[0].supName ||
                "";
            }
            this.$router.push({
              path: "/fenBaoDetail",
              query: obj
            });
          }
          return;
        } else {
          row.noticeDetailsUrl = `${addUrlPerFix(
            process.env.VUE_APP_BASE_URL
          )}/viewNoticeDetail?schemeId=${schemeId}&noticeId=${noticeId}&schemeCode=${
            row.schemeCode
          }&schemeName=${row.schemeName}&purchaseType=${row.purchaseType}`;
        }
        if (
          ["107407", "118352", "119934", "118353", "107412", "119952"].includes(
            row.baseAppId
          )
        ) {
          window.open(row.noticeDetailsUrl, "_blank");
        } else if (["100065"].includes(row.baseAppId)) {
          // 分包 /fenBaoDetail
          let objSession = {};
          if (
            sessionStorage.getItem("usedSupInfo") &&
            sessionStorage.getItem("usedSupInfo") != "undefined"
          ) {
            objSession = JSON.parse(sessionStorage.getItem("usedSupInfo"));
          }
          if (objSession?.supCode && Cookies.get("access_token")) {
            querySupJoinFlag({
              schemeId: row.schemeId,
              supCode: objSession.supCode
            }).then(res => {
              if (res.data.data.isJoin == 1) {
                return window.open(
                  addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
                    "?CLIENT_ID=" +
                    JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId +
                    "&CALLBACK_URL=" +
                    encodeURIComponent(
                      `${addUrlPerFix(
                        process.env.VUE_APP_CRMSA_URL
                      )}/bid/bidFlowIndexSub?schemeId=${
                        row.schemeId
                      }&noticeStartTime=${row.noticeTimeStart}&noticeEndTime=${
                        row.noticeTimeEnd
                      }&schemeName=${row.schemeName}&schemeCode=${
                        row.schemeCode
                      }${
                        this.supCode || row.supCode || objSession.supCode
                          ? "&supCode=" +
                            (this.supCode || row.supCode || objSession.supCode)
                          : ""
                      }&supName=${encodeURIComponent(
                        JSON.parse(sessionStorage.usedSupInfo)?.supName
                      )}&purchaseType=${row.purchaseType}&supplierFlag=1&a=${
                        JSON.parse(sessionStorage.usedSupInfo)?.secretAgentId
                      }`
                    )
                );
              } else {
                encBlackList({
                  ids: [objSession.supCode],
                  purchaseUnitId: Number(row.opUnitId)
                }).then(res => {
                  if (res.data.data.isJoin === "0") {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: res.data.data.errMsg,
                      type: "error",
                      showClose: true,
                      ccuiCustom: true
                    });
                  } else {
                    let obj = {
                      schemeId: row.schemeId,
                      noticeId: row.noticeId,
                      opUnitName: row.opUnitName,
                      opUnitId: row.opUnitId,
                      purchaseType: row.purchaseType,
                      schemeStatus: row.schemeStatus,
                      supplierFlag: 1
                    };

                    if (row.checkFlag) {
                      obj.checkFlag = row.checkFlag;
                    }
                    let objs = objSession;
                    console.log(objs, "obj...");
                    if (objs?.supCode) {
                      obj.supCode =
                        row.supCode ||
                        objs.supCode ||
                        objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
                        "";
                      obj.encSupCode =
                        row.encSupCode ||
                        objs.encSupCode ||
                        objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
                        "";
                      obj.supName =
                        row.supName ||
                        objs.supName ||
                        objs.getSupInfoByLoginInfoRspBOList[0].supName ||
                        "";
                    }
                    this.$router.push({
                      path: "/fenBaoDetail",
                      query: obj
                    });
                  }
                });
              }
            });
          } else {
            let obj = {
              schemeId: row.schemeId,
              noticeId: row.noticeId,
              opUnitName: row.opUnitName,
              opUnitId: row.opUnitId,
              purchaseType: row.purchaseType,
              schemeStatus: row.schemeStatus,
              supplierFlag: 1
            };
            if (row.checkFlag) {
              obj.checkFlag = row.checkFlag;
            }
            let objs = JSON.parse(sessionStorage.getItem("usedSupInfo"));
            // console.log(objs, "obj...");
            if (objs?.supCode) {
              obj.supCode =
                row.supCode ||
                objs.supCode ||
                objs.getSupInfoByLoginInfoRspBOList[0].supCode ||
                "";
              obj.encSupCode =
                row.encSupCode ||
                objs.encSupCode ||
                objs.getSupInfoByLoginInfoRspBOList[0].encSupCode ||
                "";
              obj.supName =
                row.supName ||
                objs.supName ||
                objs.getSupInfoByLoginInfoRspBOList[0].supName ||
                "";
            }
            this.$router.push({
              path: "/fenBaoDetail",
              query: obj
            });
          }
          return;
        } else {
          window.location.href = row.noticeDetailsUrl;
        }
      }
    },
    //登录
    handleLogin() {
      window.location.href =
        addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        encodeURIComponent(addUrlPerFix(process.env.VUE_APP_BASE_URL));
    },
    // 新用户注册
    handleRegister() {
      // 跳转注册页面
      window.location.href = `${addUrlPerFix(
        process.env.VUE_APP_SRA_URL
      )}/index`;
    },
    handleViewAll() {
      let routeUrl = this.$router.resolve({
        path: "/procurementNotice"
      });
      window.location.href = routeUrl.href;
      // this.$router.push({
      //   path: "/searchList",
      //   query: {
      //     type: 98
      //   }
      // });
      // 跳转中交供应商门户首页: sp.iccec.cn  /searchList?type=98&isJRZL=1
      // window.location.href =
      //   `${addUrlPerFix(process.env.VUE_APP_SP_URL)}` +
      //   "/searchList?type=98&isJRZL=1&searchType=首页";
    }
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  margin-top: 24px;
}

.notice-list {
  // height: 230px;
  width: 100%;
  position: relative;

  .titleBox {
    text-align: center;

    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #181818;
      line-height: 33px;
      font-style: normal;
    }

    .moreBox {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #005ef6;
      line-height: 20px;
      font-style: normal;
      cursor: pointer;
      margin-top: 5px;
    }
  }

  .navBox {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d9e2ee;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #181818;
    padding: 0 145px;
    margin-top: 32px;
    margin-bottom: 20px;
    .indexBox0,
    .indexBox1,
    .indexBox2 {
      letter-spacing: 11px;
      cursor: pointer;
      padding-left: 10px;
      &:hover {
        color: #005ef6;
      }
    }
    .indexBox3,
    .indexBox4 {
      cursor: pointer;
      &:hover {
        color: #005ef6;
      }
    }
    .itemTitle {
      flex: 1;
      min-width: 0;
      padding: 0 10px 13px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .isActive {
      border-bottom: 2px solid #005ef6;
      color: #005ef6;
    }
  }

  .notice-list-tabs {
    padding: 0 15px;
  }

  .notice-list-view-all {
    position: absolute;
    right: 15px;
    top: 20px;
    line-height: 18px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #999999;

    &:hover {
      color: #0089ef;
    }
  }

  // /deep/ .el-tabs__content .el-tab-pane {
  //   /*height: 175px;*/
  //   overflow: hidden;
  // }
}

// /deep/ .el-tabs__active-bar {
//   display: none;
// }

// /deep/ .el-tabs__item.is-active {
//   color: #4a4a4a;
//   font-size: 24px;
//   line-height: 32px;
//   font-weight: 500;
//   font-family: PingFangSC, PingFang SC;
// }

.logOutBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;

  p {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #737373;
    margin: 25px 0;
  }

  .btn1 {
    cursor: pointer;
    margin-left: 16px;
    margin-right: 10px;
    width: 109px;
    height: 32px;
    border-radius: 4px;
    background: #ffffff;
    color: #0089ef;
    border: 1px solid #0089ef;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
  }

  .btn2 {
    cursor: pointer;
    width: 109px;
    height: 32px;
    background: #0089ef;
    border-radius: 4px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    border: 1px solid #0089ef;
    color: #ffffff;
  }
}

.workDynamics {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;

  ul {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      width: 582px;
      height: 98px;
      margin-bottom: 20px;
      background: #ffffff;
      border-radius: 4px;

      .workDynamics-item-title {
        display: flex;
        padding: 20px 22px 10px;
        align-items: center;
        width: 382px;

        .iconTitle {
          // width: 56px;
          padding: 0 10px;
          height: 20px;
          background: #feb532;
          border-radius: 2px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          line-height: 20px;
          margin-right: 5px;
        }

        span:nth-child(2) {
          width: 274px;
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          color: #4a4a4a;
          font-weight: 500;
          font-family: PingFangSC, PingFang SC;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          &:hover {
            color: #0089ef;
          }
        }
      }

      .workDynamics-item-type {
        font-family: PingFangSC, PingFang SC;
        height: 18px;
        line-height: 18px;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        padding-left: 22px;

        p {
          float: left;
        }

        .item-icon {
          margin: 0px 10px;
        }

        .item-title {
          min-width: 25px;
          max-width: 100px;
          line-height: 18px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }

    .itemBox {
      display: flex;

      .infoBox {
        width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC, PingFang SC;

        .timeBox {
          font-weight: 500;
          font-size: 18px;
          color: #ff142f;
          margin-top: 5px;
        }

        .labelBox {
          font-weight: 400;
          font-size: 14px;
          color: #4a4a4a;
          margin-top: 10px;
        }

        .text-ellipsis {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 100%;
        }
      }
    }
  }

  .noneBox {
    width: 100%;
    font-size: 20px;
    text-align: center;
    padding: 20px;
    color: #686464;
  }
}

/deep/ .el-tabs__header {
  margin-bottom: 16px;
  height: 32px !important;
  line-height: 32px !important;
  padding-top: 4px;
  border-bottom: 1px solid #d9e2ee;
  margin-top: 20px;
  color: #181818;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-tabs__item.is-disabled {
  color: #4a4a4a;
}

/deep/ .el-tabs__item {
  cursor: unset;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  // padding: 0 45px;
  // margin-right: 43px;
}

// /deep/ .el-tabs__item:nth-child(-n + 4) {
//   letter-spacing: 8px;
// }
// /deep/ .el-tabs__nav-wrap {
//   width: 75%;
// }

.icon-notice-list {
  position: absolute;
  left: 20px;
  top: 16px;
  color: #0089ef;
}

.caigougonggao {
  transform: translateX(10px);
}
</style>
